export default __webpack_public_path__ + "static/media/khambenh.8a3a8c90.jpg";